import { Http } from '@/lib/http';
export class DSRLoanWaiverService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/dsr-waivers/';
  }
  createDSRLoanWaiverSetting(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  getDSRLoanWaiverSettings() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  updateDSRLoanWaiverSetting(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}
